DEFAULT_FRACTION = 0.95

App.InfiniteScrollComponent = Em.Component.extend
  classNames: ['infinite-scroll']
  fraction: DEFAULT_FRACTION

  # Селектор для слушания ближайшего родителя
  scrollClosestSelector: '.infinite-scroll'

  initScrollHandler: (->
    scrollClosestSelector = @get('scrollClosestSelector')
    elementId = @get('elementId')

    @$().closest(scrollClosestSelector).on "scroll.#{elementId}", @onScroll.bind(@)
  ).on('didInsertElement')

  destroyScrollHandler: (->
    scrollClosestSelector = @get('scrollClosestSelector')
    elementId = @get('elementId')

    @$().closest(scrollClosestSelector).off "scroll.#{elementId}"
  ).on('willDestroyElement')

  onScroll: (e) ->
    $el = Ember.$(e.target)

    height = $el.prop('scrollHeight') - $el.outerHeight()

    @sendAction('action') if $el.scrollTop() / height  > @get('fraction')
